export default class Accordion {
	constructor (accordionSelector) {
		this.accordions = document.querySelectorAll(accordionSelector);
		this.init();
	}

	init() {
		this.accordions.forEach((accordion) => {
			const button = accordion.querySelector('.accordion-header');
			const content = accordion.querySelector('.accordion-content');
			const icon = accordion.querySelector('.accordion-icon');

			button.addEventListener('click', () => this.toggleAccordion(accordion, content, icon));
		});
	}

	toggleAccordion(accordion, content, icon) {
		const isActive = accordion.classList.contains('active');
		const button = accordion.querySelector('.accordion-header');

		this.closeAllAccordions();

		if (!isActive) {
			accordion.classList.add('active');
			button.setAttribute('aria-expanded', 'true');
			content.style.maxHeight = content.scrollHeight + 'px';
			icon.style.transform = 'rotate(180deg)';
		}
	}

	closeAllAccordions() {
		this.accordions.forEach((accordion) => {
			const content = accordion.querySelector('.accordion-content');
			const icon = accordion.querySelector('.accordion-icon');
			const button = accordion.querySelector('.accordion-header');

			accordion.classList.remove('active');
			button.setAttribute('aria-expanded', 'false');
			content.style.maxHeight = null;
			icon.style.transform = 'rotate(0deg)';
		});
	}
}
